import CONST_STORAGE from 'constants/storage';
import { signOut } from 'firebase/auth';
import { auth } from 'services/firebase';

export const setStorageStartStop = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.STAR_STOP, item);

export const getStorageStartStop = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.STAR_STOP) ||
  JSON.stringify([]);

export const setStorageEndStop = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.END_STOP, item);

export const getStorageEndStop = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.END_STOP) ||
  JSON.stringify([]);

export const setStorageUserToken = (item: string) =>
  localStorage.setItem(
    CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN,
    `Bearer ${item}`,
  );

export const getStorageUserToken = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN) || '';

export const setStorageUserClaims = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS, item);

export const getStorageUserClaims = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS) ||
  JSON.stringify({});

export const setStorageLineList = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.CURRENT_LINE_LIST, item);

export const getStorageLineList = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.CURRENT_LINE_LIST) ||
  JSON.stringify([]);

export const handleLogout = (setCurrState: (item: boolean) => void) => {
  signOut(auth);

  setCurrState(false);
  localStorage.removeItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_TOKEN);
  localStorage.removeItem(CONST_STORAGE.TICKET_SALES.CURRENT_USER_CLAIMS);
};

export const getStorageLastPath = () =>
  localStorage.getItem(CONST_STORAGE.TICKET_SALES.LAST_PATH) || '';

export const setStorageLastPath = (item: string) =>
  localStorage.setItem(CONST_STORAGE.TICKET_SALES.LAST_PATH, item);

export const validationLicense = (license: string) => {
  const regexLicense = /^[a-zA-Z]{3}[0-9]{4}$/;
  const regexLicenseMercosulCar = /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$/;
  const regexLicenseMercosulMotocycle = /^[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}[0-9]{1}$/;

  if (
    regexLicense.test(license) ||
    regexLicenseMercosulCar.test(license) ||
    regexLicenseMercosulMotocycle.test(license)
  ) {
    return true;
  }
  return false;
};
